import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';
import { useOnboardingStore } from '../../store/onboardingStore';
import { useJourneyStore, JourneyStep } from '../../store/journeyStore';
import ChatContainer from '../chat/ChatContainer';

export default function OnboardingFlow() {
  const navigate = useNavigate();
  const { user, isAuthenticated } = useAuthStore();
  const { setBusinessType } = useOnboardingStore();
  const { completeStep, completedSteps } = useJourneyStore();

  useEffect(() => {
    if (!isAuthenticated || !user) {
      navigate('/login', { replace: true });
    } else {
      // Skip onboarding and mark all steps as completed
      const steps: JourneyStep[] = ['COMPANY_SETUP', 'VISION_WORKSHOP', 'BRAND_DEVELOPMENT', 'OPERATIONS_SETUP'];
      steps.forEach(step => {
        if (!completedSteps.includes(step)) {
          completeStep(step);
        }
      });
      
      // Redirect to dashboard
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, user, navigate, completeStep, completedSteps]);

  const handleResponse = (response: string) => {
    if (response.toLowerCase().includes('new business')) {
      setBusinessType('new');
      navigate('/dashboard', { replace: true });
    } else if (response.toLowerCase().includes('existing business')) {
      setBusinessType('existing');
      navigate('/dashboard', { replace: true });
    } else if (response.toLowerCase().includes('skip')) {
      // Handle skip option
      completeStep('COMPANY_SETUP');
      navigate('/dashboard', { replace: true });
    }
  };

  if (!user) {
    return null;
  }

  const initialMessage = `Welcome to Gekko HQ, ${user.name}! I'm Kari, your Personal Assistant Gekko. Before we begin, I'd like to know: are you starting a new business or do you have an existing one?`;
  
  const initialSuggestions = [
    "I'm starting a new business",
    "I have an existing business",
    "Skip setup for now"
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-white">
      <div className="max-w-4xl mx-auto pt-16 px-4">
        <div className="bg-white rounded-lg shadow-lg overflow-hidden">
          <ChatContainer
            department="Command Center"
            gekkoName="Kari"
            initialMessage={initialMessage}
            initialSuggestions={initialSuggestions}
            onResponse={handleResponse}
          />
        </div>
      </div>
    </div>
  );
}